import { CheckCircleIcon } from "@heroicons/react/solid";
import CalendarScheduleSlotModel from "../../../models/CalendarScheduleSlotModel";
import UserProfilePictureAvatar from "../../avatar/UserProfilePictureAvatar";
import SlotTime from "../SlotTime";
import { Popover } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import { useLayoutEffect, useState } from "react";
import SessionCardModal from "../../modal/SessionCardModal";
import { useAuth } from "../../../context/AuthContext";

export default function ExtendedDoneSlot({
  slot,
  onClick,
}: {
  slot: CalendarScheduleSlotModel;
  onClick: (slot: CalendarScheduleSlotModel) => void;
}) {
  const [open, setOpen] = useState<boolean>(false);
  const { userType }: any = useAuth();

  const [popperElement, setPopperElement] =
    useState<HTMLDivElement | null>(null);
  const { i18n } = useTranslation();

  const [className, setClassName] = useState<string>("");
  useLayoutEffect(() => {
    // Decide if the dropdown should be open to the top or bottom
    if (!!popperElement) {
      const windowWidth = window.innerWidth;
      const { right, top } = popperElement?.getBoundingClientRect();
      const left = windowWidth - right;
      if (i18n.dir() === "ltr") {
        if (left >= 448) {
          setClassName("left-[100%] top-[0.5rem]");
        } else if (right >= 448) {
          setClassName("right-[100%] top-[0.5rem]");
        } else if (top >= 448) {
          setClassName("top-[100%]");
        } else {
          setClassName(" -top-[3%]");
        }
      } else {
        if (right >= 448) {
          setClassName("right-[100%] top-[0.5rem]");
        } else if (left >= 448) {
          setClassName("left-[100%]  top-[0.5rem]");
        } else if (top >= 448) {
          setClassName("top-[100%]");
        } else {
          setClassName(" -top-[3%]");
        }
      }
    }
  }, [popperElement, i18n]);
  return (
    <Popover
      as="div"
      className="relative w-full  z-0 m-1"
      ref={setPopperElement}
    >
      {({ open }) => (
        <>
          <Popover.Button
            role="button"
            className="hover:bg-gray-50 border border-green-400 w-full overflow-y-auto   h-full z-0 rounded-md bg-white px-2 py-[6px]"
          >
            <p
              data-cy="doneIcon"
              className="text-green-700 text-xs leading-5 font-normal flex items-center justify-between"
            >
              <SlotTime time={slot.startTime} />
              <CheckCircleIcon
                className="h-5 w-5 text-green-400"
                aria-hidden="true"
              />
            </p>
            <div className="mt-2 flex flex-col items-start gap-1 text-white">
              <UserProfilePictureAvatar
                profilePictureUrl={slot.student?.profile_picture_url}
                className="w-8 h-8"
                alt={slot.student?.fullName}
              />
              <div className="flex flex-col items-start gap-[2px]">
                <h3 className="text-xs font-bold text-green-700">
                  {slot.student?.fullName}
                </h3>
                <p className="text-xs font-normal text-green-500">
                  {slot.student?.recitation}
                </p>
              </div>
            </div>
          </Popover.Button>
          {!!slot && (
            <>
              <SessionCardModal
                session={slot}
                userType={userType}
                open={open}
                setOpen={setOpen}
                className={className}
                cancel={false}
              />
            </>
          )}
        </>
      )}
    </Popover>
  );
}
